import Vue from 'vue'
import Router from 'vue-router'
import { Home, Task } from '@/views'
import store from './store'

Vue.use(Router)

const API_BASE_URL = process.env.VUE_APP_AUTH_BASE_URL

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login/:token?',
      name: 'login'
      // component: Login
    },
    {
      path: '/task/:id',
      name: 'task',
      component: Task
    },
    {
      // redirect any other route back to home
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    if (store.getters.isAuthenticated) {
      next({ name: 'home' })
      return
    } else {
      if (to.params.token) {
        // check url param token
        store.commit('updateAuthToken', to.params.token)
        next({ name: 'home' })
        return
      } else {
        // if not, redirect to auth portal
        const portal = `${API_BASE_URL}?next=${window.location.origin}/%23/login/{token}`
        window.location.href = portal
      }
    }
  }

  const protectedRoutes = [ 'home', 'task' ]
  if (protectedRoutes.includes(to.name)) {
    if (!store.getters.isAuthenticated) {
      next({ name: 'login' })
      return
    }
  }

  if (to.name === 'task') {
    store.commit('clearTask')
    store.dispatch('fetch5cards', { params: { id: to.params.id } })
  }
  next()
})

export default router
